import { Component, ChangeDetectionStrategy, ViewChild, TemplateRef, } from '@angular/core';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours, } from 'date-fns';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView, } from 'angular-calendar';
import { OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import moment from 'moment';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  green: {
    primary: '#42f569',
    secondary: '#42f569',
  },
};

@Component({
  selector: 'app-attendance',
  templateUrl: './attendance.component.html',
  styleUrls: ['./attendance.component.css']
})


export class AttendanceComponent implements OnInit {
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;

  view: CalendarView = CalendarView.Month;

  CalendarView = CalendarView;

  viewDate: Date = new Date();

  modalData: {
    action: string;
    event: CalendarEvent;
  };

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fas fa-fw fa-pencil-alt"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fas fa-fw fa-trash-alt"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.events = this.events.filter((iEvent) => iEvent !== event);
        this.handleEvent('Deleted', event);
      },
    },
  ];

  refresh: Subject<any> = new Subject();

  events: CalendarEvent[] = [
    // {
    //   start: subDays(startOfDay(new Date()), 1),
    //   end: addDays(new Date(), 1),
    //   title: 'A 3 day event',
    //   color: colors.red,
    //   actions: this.actions,
    //   allDay: true,
    //   resizable: {
    //     beforeStart: true,
    //     afterEnd: true,
    //   },
    //   draggable: true,
    // },
    // {
    //   start: startOfDay(new Date()),
    //   title: 'An event with no end date',
    //   color: colors.yellow,
    //   actions: this.actions,
    // },
    // {
    //   start: subDays(endOfMonth(new Date()), 3),
    //   end: addDays(endOfMonth(new Date()), 3),
    //   title: 'A long event that spans 2 months',
    //   color: colors.blue,
    //   allDay: true,
    // },
    // {
    //   start: addHours(startOfDay(new Date()), 2),
    //   end: addHours(new Date(), 2),
    //   title: 'A draggable and resizable event',
    //   color: colors.yellow,
    //   actions: this.actions,
    //   resizable: {
    //     beforeStart: true,
    //     afterEnd: true,
    //   },
    //   draggable: true,
    // },
  ];

  activeDayIsOpen: boolean = true;


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  filterempid: any = null;
  fromdate: any = new Date();
  todate: any = new Date();
  filterstatus: string = "";


  formname: string = "InsuranceReport";

  empColl: any = [];
  attendanceColl: any = [];

  constructor(private modal: NgbModal, private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, private datePipe: DatePipe, private productFindService: NgbModal) {
    this.fnServiceChanges();
  }
  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fromdate.setDate(this.fromdate.getDate() - 30);

    var date = new Date();
    this.fromdate = new Date(date.getFullYear(), date.getMonth(), 1);
    this.todate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    
    this.fngetEmployee();
  }

  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fngetEmployee() {
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get
  fngetAttendance() {
    if (this.showProgress) {
      return;
    }
   if (!this.filterempid) {
    return       
   }
    
    this.fnShowProgress();
    this.fromdate.setDate(this.fromdate.getDate() - 30);

    var data = {
      'insuranceid': 0,
      'empid': this.filterempid,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': this.filterstatus,
      'fromdate': this.fnFormatDatetime(this.fromdate),
      'todate': this.fnFormatDatetime(this.todate),
    }
    this.appService.getAttendanceReport(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.attendanceColl = res.json().result;
            
            this.events=[]
            for (let abo of this.attendanceColl) {
              this.events.push( 
                {
                  start:this.fnConvertDatetime(this.fnFormatDatetime(abo.logdate)),
                  end:this.fnConvertDatetime(this.fnFormatDatetime(abo.logdate)),
                  title: abo.workstatus,
                  color: this.fnSetColorCode(abo.shortworkstatus),
                  cssClass: abo.holidaysname,
                  //actions: this.actions,
                 }
               )
            }
        
            this.refresh.next()
            

          } else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    this.events = this.events.map((iEvent) => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd,
        };
      }
      return iEvent;
    });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this.modal.open(this.modalContent, { size: 'lg' });
  }

  addEvent(): void {
    this.events = [
      ...this.events,
      {
        title: 'New event',
        start: startOfDay(new Date()),
        end: endOfDay(new Date()),
        color: colors.red,
        draggable: true,
        resizable: {
          beforeStart: true,
          afterEnd: true,
        },
      },
    ];
  }

  deleteEvent(eventToDelete: CalendarEvent) {
    this.events = this.events.filter((event) => event !== eventToDelete);
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;


    this.fngetAttendance()
    
  }


  fnSetColorCode(mode) {
    if (mode === "P") {
      return colors.green
    }
    else  if (mode === "L") {
      return colors.yellow
    }
    else  if (mode === "W") {
      return colors.blue
    }      
    else  if (mode === "H") {
      return colors.yellow
    }
    else  if (mode === "A") {
      return colors.red
    }
    else {
      return colors.yellow
    }
  }


  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }

  }

  fnMomentTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('hh:mm');//  
    }
    else {
      return '';
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }




}
